export default __webpack_public_path__ + "static/media/support_header.8c5997ae.png";